// Pure display formatting for Scheduler's typed output contract. The contract itself remains the success
// authority; this module only renders its exact closed kind tokens and minimum counts for the browser.

import type { ScheduleOutputContract } from '../projections.ts';

export function scheduleMachineSuccessText(contract: ScheduleOutputContract | null): string {
  if (contract === null) return 'No typed machine success criteria are recorded.';
  return contract.requirements
    .map((requirement) => `${requirement.kind} (minimum ${String(requirement.minCount)})`)
    .join('; ');
}
